export default __webpack_public_path__ + "static/media/webhooks.21e7595c.svg";